export default function useProcessForcedRefreshMessage() {
    return () => {
        console.log('Forcing a refresh')
        window.location.reload()
    }
}
